import { useMutation } from "@tanstack/react-query";
import { fetch } from "../fetch";
import { schemas } from "@convergence/client";

export async function deleteMe() {
    return await fetch("/user/me", { method: "DELETE" }, schemas.SuccessDto);
}

export const useDeleteMeMutation = () => {
    return useMutation({
        mutationFn: async () => {
            return deleteMe();
        },
    });
}